var aCallable = require('../internals/a-callable');

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/get-method.js
// module id = 57
// module chunks = 49